import { useMap } from "react-leaflet";
import React, { useEffect, useState } from "react";
import L from "leaflet";
import "leaflet-minimap";

function MiniMapControl({ ethiopiaRegions, selectedRegionalState }) {
  const map = useMap();

  useEffect(() => {
    const miniLayer = L.tileLayer(
      "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      { attribution: "&copy; OpenStreetMap contributors" }
    );

    const miniMap = new L.Control.MiniMap(miniLayer, {
      toggleDisplay: true,
      position: "bottomright",
      zoomLevelOffset: -4,
    }).addTo(map);

    // Add region outlines inside minimap
    const miniMapMap = miniMap.getContainer().querySelector("iframe")?._leaflet_map;
    if (miniMapMap && ethiopiaRegions) {
      const regionLayer = L.geoJSON(ethiopiaRegions, {
        style: (f) => ({
          color: f.properties.shapeName === selectedRegionalState ? "red" : "#555",
          weight: f.properties.shapeName === selectedRegionalState ? 3 : 1,
          fill: false,
        }),
      });
      regionLayer.addTo(miniMapMap);
    }

    return () => {
      miniMap.remove();
    };
  }, [map, ethiopiaRegions, selectedRegionalState]);

  return null;
}

export default MiniMapControl;